import { Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, ViewChild, inject } from '@angular/core';
import { UserService } from './services/common/user.service';
import localeBn from '@angular/common/locales/bn';
import { isPlatformBrowser, isPlatformServer, registerLocaleData } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  // Store Data
  isBrowser: boolean;
  isServer: boolean;
  @ViewChild('scroll') scroll: ElementRef;

  // Inject
  private readonly userService = inject(UserService);
  public readonly platform = inject(PLATFORM_ID);


  ngOnInit() {

    this.userService.autoUserLoggedIn();

    registerLocaleData(localeBn, 'bn');
    this.isBrowser = isPlatformBrowser(this.platform);
    this.isServer = isPlatformServer(this.platform);

    this.jj();
  }

  private jj() {

    function productPrice(number) {

      // Extract the integer part
      const integer = Math.floor(number);
      const fractional = number - integer;

      //Converting the fractional to the integer
      const frac2int = (fractional * 100) / 5;
      const fracCeil = Math.ceil(frac2int);

      //transforming inter into fractional
      const FracOut = (fracCeil * 5) / 100;
      const ans = integer + FracOut;

      const finalOutput = (Math.round(ans * 100) / 100).toFixed(2);

    }

    productPrice(21.59878);
  }

  /**
   * scrollTop();
   */
  scrollTop() {
    window.scrollTo(0, 0);
  }

  @HostListener('window:scroll')
  hideShowScrollBtn() {
    if (window.scrollY > 500) {
      this.scroll.nativeElement.style.display = 'flex';
    } else {
      this.scroll.nativeElement.style.display = 'none';
    }
  }


}
